import { GammaAPIService } from '@/service/gamma-api.service';
import mitt from 'mitt';

const emitter = mitt();
export function emit(event: string, data: any) {
    emitter.emit(event, data);
    if (event === BerwowEvent.TrackingEvent) {
        GammaAPIService.logEvent(data.event, data);
    }
}
export function on(event: string, listener: any) {
    emitter.on(event, listener);
}

export enum BerwowEvent {
    SettingsLoaded = "settingsLoaded",
    UnavailableAmount = "unavailableAmount",
    RecommendationsError = "recommendationsError",
    TrackingEvent = "tracking-event",
    Quote = "quote",
}
export enum QuoteOrigin {
    MenuItem = "menu-item",
    ActionButton = "action-button",
}
export enum LayoutEvent {
    Toggle = "toggle",
    ScrollToContent = "scrollToContent",
    ExpandMenuBar = "expandMenuBar",
    StartAgainClicked = "startAgainClicked",
    ShowGrantDialog = "showGrantDialog",
    ShowMortgageDialog = "showMortgageDialog",
    ShowHouseInfoForm = "showHouseInfoForm",
}

export enum TrackingEvent {
    QuestionareInformationSent = "questionare_information_sent",
    PageMounted = "page_mounted",
    RecommendationsReportResult = "recommendations_report_result",
    RecommendationsOnSubmit = "recommendations_on_submit",
    UserChangedRecommendations = "user_changed_recommendations",
    UserChangedLoan = "user_changed_loan",
    UserClickedTab = "user_clicked_tab",
}